import React from "react";

import { EditIcon } from "./Icons";

export function PrimaryButton(props) {
  let isDisabled = props.isDisabled;
  return (
    <button
      {...props}
      disabled={isDisabled}
      className={`${
        props.className
      } font-medium font-ibmPlexSans text-sm text-black focus:outline-none rounded-lg ${
        !isDisabled
          ? " bg-green-medium hover:opacity-80"
          : "bg-gray pointer-events-none"
      }`}
    >
      {props.children}
    </button>
  );
}

export function CreateTeamButton(props) {
  return (
    <button
      {...props}
      className={`${props.className}font-semibold text-sm focus:outline-none rounded-lg`}
    >
      {props.children}
    </button>
  );
}

export function SecondaryButton(props) {
  return (
    <button
      {...props}
      className={`${props.className} bg-neutral-800 border border-green-500 hover:text-green-400 hover:text-border-400 text-green-500 font-semibold text-white focus:outline-none rounded-lg`}
    >
      {props.children}
    </button>
  );
}

export function IconButton(props) {
  return (
    <button
      {...props}
      className={`${
        props.className
      } relative text-white text-sm pl-6 bg-no-repeat bg-contain bg-left ${
        props.disabled === true
          ? "opacity-50 pointer-events-none grayscale select-none"
          : "opacity-80 hover:opacity-100"
      } focus:outline-none`}
    >
      {props.children}
    </button>
  );
}
export const DropdownButton = (props) => {
  return (
    <button
      id="dropdownDefault"
      data-dropdown-toggle="dropdown"
      className={`${
        props.style && props.style
      } text-white outline-none font-normal rounded-lg text-sm py-1 pl-2 text-center flex items-center justify-between bg-gunmetal-darker`}
      type="button"
      onClick={props.onClick}
    >
      <span className="capitalize">{props.title}</span>
      <svg
        className="mr-2 w-4 h-4"
        aria-hidden="true"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M19 9l-7 7-7-7"
        ></path>
      </svg>
      {props.childen}
    </button>
  );
};

export function TextInput(props) {
  return (
    <input
      {...props}
      className={`${props.className} appearance-none bg-transparent text-white border border-neutral-500 rounded-md py-2 px-2 leading-tight focus:outline-none focus:text-white focus:border-neutral-400`}
    />
  );
}

export function CouponApplied({ promoCode, onExit }) {
  return (
    <div className="flex max-w-lg flex-col font-mullish bg-neutral-800 rounded-md shadow-lg ml-auto mr-auto p-5 text-neutral-200 text-sm font-normal">
      <h2 className="mb-2 font-poppins text-lg font-semibold">
        Your discount code has been applied!
      </h2>
      <p className="mb-3">
        You can continue to explore our product for free and once you are ready
        to discover the full potential of Beatoven.ai, you can click on Upgrade
        and subscribe to our Pro plan.
      </p>
      <p className="mb-3">
        You will see your discount code ({promoCode}) automatically applied on
        the payment screen.
      </p>
      <PrimaryButton className="w-16 h-8 ml-auto mr-auto" onClick={onExit}>
        Got it
      </PrimaryButton>
    </div>
  );
}

export function RadioSelect(props) {
  return (
    <div
      className="cursor-pointer w-full flex items-start mb-1 hover:bg-neutral-700 rounded-lg p-2"
      onClick={props.onClick}
    >
      <button
        className={`${
          props.checked ? "bg-radio" : "bg-circle"
        } bg-left pl-3 w-4 h-5 bg-no-repeat`}
      />
      {props.children}
    </div>
  );
}

export function HoldForPreview() {
  return (
    <span className="text-xs text-neutral-500">
      Tap and hold to preview. Tap once to select.
    </span>
  );
}

export function TickMark(props) {
  let color = props.color || "#31F080";
  color = props.active ? color : "#fff";
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      className="feather feather-check"
    >
      <polyline points="20 6 9 17 4 12"></polyline>
    </svg>
  );
}

export function EditButton(props) {
  return (
    <button
      onClick={props.onClick}
      disabled={props.disabled}
      className={
        "inline-block items-center flex text-center h-7 py-0.5 text-sm px-3 rounded-lg bg-quartz hover:opacity-90 h-auto " +
        props.classList
      }
    >
      <EditIcon />
      <span className="ml-2 hidden lg:block">{props.text || "Edit"}</span>
      {props.childen}
    </button>
  );
}

export function CloseButton(props) {
  return (
    <button onClick={() => props.onExit()} className={props.className}>
      <img
        src="/close.svg"
        alt="Close"
        data-tip="Close"
        className="opacity-80 hover:opacity-100 w-full cursor-pointer"
      />
    </button>
  );
}

export const defaultPrompts = [
  "Create a song that would fit a 16-bit video game from the 90s (SEGA Genesis) for a video game",
  "Chill house music that can hype up the vibes at a bar",
  "Reggae fusion, hammond organ, soul, slow, trip-hop, guitar, bass, tender",
  "ambient, techno, meditation, drum machine, synthesizer with synth bass instrumental",
  "Jazz-hiphop music for a product demo video",
  "Boss, Deep, Energetic, Vocals, Choir, Medieval music for a war scene",
  "suspense thriller music for scam exposing video",
  "create a lofi hip hop track for studying",
  "Japanese countryside, a haunted house, night, creepy feeling, short film",
  "Soft piano ambient music for a nature documentary",
];

export function DotsLoader() {
  return (
    <span className="inline-flex ml-1 ">
      <span className="dot animate-dot-loader animation-delay-0 text-3xl">
        .
      </span>
      <span className="dot animate-dot-loader animation-delay-200 text-3xl">
        .
      </span>
      <span className="dot animate-dot-loader animation-delay-400 text-3xl">
        .
      </span>
    </span>
  );
}
